import React from "react";

import { FooterNavigationBlock as FooterNavigationBlockValue } from "@reactivated";

import { StreamField } from "@thelabnyc/thelabui/src/components/StreamField";
import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import { ReactivatedContext as Context } from "../../context";
import { FooterColumns } from "./FooterColumns";
import { FooterLegal } from "./FooterLegal";
import { FooterSocialMedia } from "./FooterSocialMedia";
import { NewsletterSignup } from "./NewsletterSignup";

import themeStyles from "../../styles/themes-2026.module.scss";
import styles from "./index.module.scss";

interface IProps extends React.HTMLAttributes<HTMLDivElement> {
    value: FooterNavigationBlockValue;
}

export const FooterNavigation = React.forwardRef<HTMLDivElement, IProps>(
    ({ value: propsValue, ...props }, ref) => {
        const context = React.useContext(Context);
        const is2026 = context.DESIGN_VERSION === "v2026";

        return (
            <footer
                {...props}
                ref={ref}
                className={concatClassNames([
                    is2026 ? themeStyles.black : styles.root,
                    props.className,
                ])}
            >
                <div className={styles.mainContentContainer}>
                    <div className={styles.inner}>
                        <StreamField
                            components={{
                                newsletter_signup: NewsletterSignup,
                                columns: FooterColumns,
                                social_media: FooterSocialMedia,
                                legal: FooterLegal,
                            }}
                            value={propsValue}
                            tagName={React.Fragment}
                        />
                    </div>
                </div>
            </footer>
        );
    },
);
